import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Button } from 'react-bootstrap'

/**
 * A basic component button for the user to navigate through the sections
 * of the calculator. Renders "Back" or "Next" and provides a react-router
 * Link to the relevant section based on props
 */
export default class NavBtn extends Component {
  /**
   * Render the component
   * @returns
   */
  render () {
    let btnStyle = {
      fontStyle: 'normal'
    }

    let btnText = 'Next'
    if (this.props.back) {
      btnText = 'Back'
      btnStyle.float = 'left'
    } else {
      btnStyle.float = 'right'
    }

    return (
      <Link to={'/calculator/' + this.props.nextSection}>
        <Button bsSize='large' style={btnStyle}>
          {btnText}
        </Button>
      </Link>
    )
  }
}

NavBtn.propTypes = {
  nextSection: PropTypes.number.isRequired,
  back: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/sections/NavBtn.js